export * from './CoursePreview';
export { default } from './CoursePreview';
